import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  countries: [],
  country: {
    id: 0,
    name: "",
    code: "",
    status: false,
  },
  countryValidation: {
    isValid: true,
    name: {
      isValid: true,
      errorMessage: "El campo nombre no debe estar vacio",
    },
    description: {
      isValid: true,
      errorMessage: "El campo descripcion no debe estar vacio",
    },
    code: {
      isValid: true,
      errorMessage: "El campo código no debe estar vacio",
    },
  },
};

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    restartState(state) {
      state.country = {};
      state.countries = [];
    },
    setCountries(state, actions) {
      state.countries = actions.payload.countries;
      state.country = {};
    },
    setCountry(state, actions) {
      state.country = actions.payload.country;
      state.countries = [];
    },
    modifyPropertyValue(state, actions) {
      state.country[actions.payload.id] = actions.payload.value;
    },
    setCountryValidation(state, actions) {
      state.countryValidation = {
        name: {
          ...state.countryValidation.name,
          isValid: actions.payload.name !== "",
        },
        code: {
          ...state.countryValidation.code,
          isValid: actions.payload.code !== "",
        },
      };
      state.countryValidation.isValid =
        state.countryValidation.code.isValid;
    },
    setFieldValid(state, actions) {
      state.countryValidation[actions.payload.id].isValid = actions.payload.value;
    },
  },
});

export const countryActions = countrySlice.actions;
export default countrySlice;
